<template>
  <v-col lg="3" sm="6" md="7" cols="12">
    <v-card>
      <v-card-title class="flex-nowrap pa-6 pb-1">
        <p class="text-truncate">{{ title }}</p>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="pa-6 pt-0 mb-1">
        <v-row no-gutters>
          <v-col cols="12">
            <ApexChart
              height="76"
              type="donut"
              :options="chart_options"
              :series="chart_series"
            ></ApexChart>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import ApexChart from "vue-apexcharts";

@Component({
  components: { ApexChart },
})
export default class DashboardCardFaultsPieChart extends Vue {
  @Prop() readonly title: string;
  @Prop() readonly chart_options: any;
  @Prop() readonly chart_series: any;
}
</script>

<style lang="scss">
@import "../../styles/app";

.dashboard-page {
  .page-title {
    padding-bottom: 20px;
    @include media-breakpoint-up(sm) {
      padding-bottom: 0;
    }
  }
  .apexcharts-legend-series {
    padding: 2px 5px 3px;
    display: flex;
    align-items: center;
    .apexcharts-legend-marker {
      margin-right: 8px;
    }
  }
  .main-chart-select {
    font-size: 1rem;
    margin-right: 10px;
    fieldset {
      border-width: 1px !important;
      border-color: $text-grey !important;
      color: $text-grey !important;
    }
    .v-select__selection {
      color: $text-color !important;
    }
  }
  .v-card {
    .v-card__text {
      .subtext {
        font-size: 1.142rem;
        font-weight: 400;
        color: $title-grey;
      }
      .subtext-index {
        font-size: 11px;
        color: $text-color;
        font-weight: 400;
      }
    }
  }
}

.v-menu__content {
  box-shadow: $card-shadow !important;
  .v-list-item__content .v-list-item__title {
    font-size: 1rem;
    font-weight: 400;
  }
}
.button-shadow {
  box-shadow: $button-shadow;
}
</style>
